"use client"
 
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Badge } from "../../components/ui/badge"
import { Button } from "../../components/ui/button"
import { Award, Trophy, Star, Medal, ChevronRight, Calendar, X } from "lucide-react"
import SEO from "../SEO"
 
 
export default function AwardsPage() {
  const awardsSchema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaamhospitals.com/",
    "logo": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png",
    "description": "Pranaam Hospitals is a NABH-accredited multi-specialty hospital in Hyderabad recognized with numerous awards for excellence in healthcare and patient safety.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "telephone": "+91-99660-60000",
      "availableLanguage": ["English", "Telugu", "Hindi"]
    },
    "sameAs": [
      "https://www.facebook.com/pranaamhospitals",
      "https://www.instagram.com/pranaamhospitals",
      "https://www.linkedin.com/company/pranaamhospitals"
    ]
  },
 
  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://pranaamhospitals.com/about/awards"
    },
    "headline": "Awards & Recognitions of Pranaam Hospitals",
    "description": "Pranaam Hospitals has received multiple awards and recognitions for clinical excellence, patient safety, and quality healthcare services in Hyderabad.",
    "image": "https://pranaamhospitals.com/wp-content/uploads/2025/hospital-awards.jpg",
    "author": {
      "@type": "Organization",
      "name": "Pranaam Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Pranaam Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png"
      }
    },
    "datePublished": "2015-01-01",
    "dateModified": "2025-04-01",
    "keywords": [
      "Pranaam Hospitals awards",
      "best hospital awards Hyderabad",
      "NABH accredited hospital",
      "healthcare excellence awards Telangana"
    ]
  }
];
 
  const [selectedCategory, setSelectedCategory] = useState("all")
  const [selectedImage, setSelectedImage] = useState(null)
 
  // const categories = [
  //   { id: "all", name: "All Awards" },
  //   { id: "national", name: "National Rankings" },
  //   { id: "accreditation", name: "Accreditations" },
  //   { id: "specialties", name: "Specialty Awards" },
  //   { id: "innovation", name: "Innovation" },
  // ]
 
  const [awardsData, setAwardsData] = useState(null)
const [data, setData] = useState(null)
useEffect(() => {
  fetch("/wp-json/custom/v1/awards-page?page_id=21421")
    .then(res => res.json())
    .then(res => setAwardsData(res))
}, [])
 
const filteredAwards =
  selectedCategory === "all"
    ? awardsData?.items || []
    : awardsData?.items?.filter(
        (award) => award.category === selectedCategory
      ) || []
 
 const getIconComponent = (iconName) => {
  switch (iconName) {
    case "trophy":
      return Trophy
    case "medal":
      return Medal
    case "star":
      return Star
    default:
      return Award
  }
}
 
  return (
    <>
    <SEO
  title="Awards & Recognitions | Pranaam Hospitals Hyderabad"
  description="Explore the awards and recognitions earned by Pranaam Hospitals for excellence in healthcare, patient safety, and medical innovation in Hyderabad."
  canonical="https://pranaamhospitals.com/about/awards"
  robots="index, follow"
  author="Pranaam Hospitals"
  publisher="Pranaam Hospitals"
  keywords="Pranaam Hospitals awards, hospital awards Hyderabad, NABH accredited hospital Hyderabad,
            best hospital awards Telangana, healthcare excellence awards Hyderabad,
            Pranaam Hospitals recognitions, multispecialty hospital awards"
  schema={awardsSchema}
/>
    <div className="min-h-screen bg-white">
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Recognition & Excellence</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                Awards & <span className="text-primary">Achievements</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Although hitting milestones isn't our ultimate goal, we're humbled by the praise and accolades awarded
                to us by virtue of our passion, zeal and excellence in medicine serving countless patients to help them
                live their best lives.
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-8">
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Trophy className="w-4 h-4 mr-2" />
                  50+ Awards
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Medal className="w-4 h-4 mr-2" />
                  NABH & NABL Certified
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Star className="w-4 h-4 mr-2" />
                  National Recognition
                </Badge>
              </div>
            </div>
          </div>
        </section>
 
        {/* Statistics Section */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
              <div className="text-center p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <Trophy className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">50+</h3>
                <p className="text-gray-600">Total Awards</p>
              </div>
              <div className="text-center p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <Award className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">15+</h3>
                <p className="text-gray-600">National Rankings</p>
              </div>
              <div className="text-center p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <Medal className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">4</h3>
                <p className="text-gray-600">Major Certifications</p>
              </div>
              <div className="text-center p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <Star className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">10+</h3>
                <p className="text-gray-600">Years of Recognition</p>
              </div>
            </div>
          </div>
        </section>
 
        {/* Filter Section */}
        {/* <section className="py-8 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto">
              <div className="flex flex-wrap justify-center gap-3">
                {categories.map((category) => (
                  <Button
                    key={category.id}
                    variant={selectedCategory === category.id ? "default" : "outline"}
                    onClick={() => setSelectedCategory(category.id)}
                    className="rounded-full"
                  >
                    {category.name}
                  </Button>
                ))}
              </div>
            </div>
          </div>
        </section> */}
 
        {/* Awards Grid */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
 
                {awardsData?.items?.map((award, index) => {
                  const IconComponent = getIconComponent(award.icon)
 
                  return (
                    <div
                      key={index}
                      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all group"
                    >
                      <div className="flex items-start gap-4">
 
                        <div className="flex-shrink-0">
                          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 group-hover:bg-primary transition-colors">
                            <IconComponent className="w-6 h-6 text-primary group-hover:text-white" />
                          </div>
                        </div>
 
                        <div className="flex-1">
                          {award.year && (
                            <div className="flex items-center gap-2 mb-2">
                              <Calendar className="w-4 h-4 text-primary" />
                              <span className="text-sm font-medium text-primary">
                                {award.year}
                              </span>
                            </div>
                          )}
 
                          <h3 className="font-bold mb-2 text-gray-900 group-hover:text-primary transition-colors">
                            {award.title}
                          </h3>
 
                          <p className="text-sm text-gray-600">
                            {award.description}
                          </p>
                        </div>
 
                      </div>
                    </div>
                  )
                })}
 
              </div>
            </div>
          </div>
        </section>
 
        {/* Award Gallery Section */}
        <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <Badge className="mb-2">Gallery</Badge>
                <h2 className="mb-4 text-3xl font-bold md:text-4xl">Our Proud Moments</h2>
                <p className="text-muted-foreground max-w-2xl mx-auto">
                  Visual documentation of our achievements and recognition over the years
                </p>
              </div>
 
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {awardsData?.gallery?.map((image, index) => (
                  <div
                    key={index}
                    className="relative h-48 md:h-64 lg:h-80 bg-white border rounded-lg overflow-hidden group cursor-pointer"
                    onClick={() => setSelectedImage(image.url || image)}
                  >
                    <img
                      src={image.url || image}
                      alt={`Award ${index + 1}`}
                      className="w-full h-full object-contain p-2 group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                      <Award className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
 
        {/* Major Accreditations */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <Badge className="mb-2">Certifications</Badge>
                <h2 className="mb-4 text-3xl font-bold md:text-4xl">Major Accreditations</h2>
                <p className="text-muted-foreground max-w-2xl mx-auto">
                  Quality certifications that validate our commitment to excellence
                </p>
              </div>
 
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-gray-50 rounded-lg p-8 border-2 border-primary/20">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                        <Medal className="w-8 h-8 text-primary" />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2">NABH Accreditation</h3>
                      <p className="text-gray-600 mb-3">
                        National Accreditation Board for Hospitals and Healthcare Providers
                      </p>
                      <div className="space-y-2">
                        <div className="flex items-center gap-2 text-sm">
                          <span className="font-medium text-primary">Initial:</span>
                          <span className="text-gray-600">November 2015</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <span className="font-medium text-primary">Re-accredited:</span>
                          <span className="text-gray-600">January 2020</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
 
                <div className="bg-gray-50 rounded-lg p-8 border-2 border-primary/20">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                        <Medal className="w-8 h-8 text-primary" />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2">NABL Accreditation</h3>
                      <p className="text-gray-600 mb-3">National Accreditation Board for Laboratories</p>
                      <div className="space-y-2">
                        <div className="flex items-center gap-2 text-sm">
                          <span className="font-medium text-primary">Certified:</span>
                          <span className="text-gray-600">January 2021</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
 
        {/* CTA Section */}
        <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto bg-gradient-to-r from-primary to-primary/90 rounded-lg shadow-xl p-8 md:p-12 text-white text-center">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Experience Award-Winning Healthcare</h2>
              <p className="mb-8 text-lg opacity-90">
                Join thousands of patients who have trusted our nationally recognized healthcare services.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button size="lg" variant="secondary" asChild>
                    <a
                      href="/book-now"
                      rel="noopener noreferrer"
                    >
                    <Calendar className="w-5 h-5 mr-2" />
                    Book an Appointment
                  </a>
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-white/10 border-white text-white hover:bg-white hover:text-primary"
                  asChild
                >
                  <Link to="/about">
                    Learn More About Us
                    <ChevronRight className="w-5 h-5 ml-2" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
 
      {/* Image Popup / Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 md:p-8 animate-in fade-in duration-200"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-gray-300 transition-colors z-[110]"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-10 h-10" />
          </button>
          <div className="relative max-w-5xl w-full h-full flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage}
              alt="Award Full View"
              className="max-w-full max-h-full object-contain shadow-2xl rounded-sm"
            />
          </div>
        </div>
      )}
    </div>
    </>
  )
}